import React, { useState } from 'react'
import { Group, Text } from '@mantine/core'
import ScratchRecordModal from './ScratchRecordModal'
import PointsRecordModal from './PointsRecordModal'
import GuaranteedDrawHint from './GuaranteedDrawHint'
import { useLotteryData } from '../../hooks'

interface UserPointsHeaderProps {}

const ScratchCardHeader: React.FC<UserPointsHeaderProps> = () => {
  const [scratchModalOpen, setScratchModalOpen] = useState(false)
  const [pointsModalOpen, setPointsModalOpen] = useState(false)
  const { lotteryChances, currentPoints, pointsPerLotteryNum, currentMerchant } = useLotteryData()

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: 8,
          marginLeft: 8,
          marginTop: 12,
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation()
            setPointsModalOpen(true)
          }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            cursor: 'pointer',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Group gap={2} style={{ marginBottom: 2 }}>
            <Text fw={900} style={{ fontSize: 20, color: '#3A2323' }}>
              可抽奖次数
            </Text>
            <Text fw={900} style={{ fontSize: 20, color: '#A13A1A' }}>
              {lotteryChances}次
            </Text>
          </Group>

          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Text
              size="xs"
              style={{
                color: '#666',
                fontSize: 12,
                opacity: 0.8,
              }}
            >
              {pointsPerLotteryNum}积分=1次 • 当前{parseInt(currentPoints || '0', 10)}积分
            </Text>
            <span style={{ fontSize: 10, color: '#999' }}>👆点击查看明细</span>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            fontSize: 16,
            color: '#999999',
            fontWeight: 700,
            marginRight: 8,
            position: 'relative',
            zIndex: 2,
          }}
          onClick={(e) => {
            e.stopPropagation()
            setScratchModalOpen(true)
          }}
        >
          抽奖记录
        </div>
      </div>
      <GuaranteedDrawHint remainingDrawsToGuaranteed={currentMerchant?.remainingDrawsToGuaranteed} />
      <ScratchRecordModal opened={scratchModalOpen} onClose={() => setScratchModalOpen(false)} />
      <PointsRecordModal
        opened={pointsModalOpen}
        onClose={() => setPointsModalOpen(false)}
        pointsPerLotteryNum={pointsPerLotteryNum}
        currentPoints={parseInt(currentPoints || '0', 10)}
        lotteryChances={lotteryChances}
      />
    </>
  )
}

export default ScratchCardHeader
